module.exports = __webpack_public_path__ + "img/smooth-lines.435e72c0.svg";